import { useQuery } from '@tanstack/react-query'
import {
	GetReturnLossHistoryRequest,
	GetReturnLossHistoryResponse,
} from '@/modules/promotion/type'
import { getReturnLossHistoryList } from '../../services'
import { ReturnLossHistoryQueryKeys } from '@/modules/promotion/keys'

const useQueryGetReturnLossHistory = (payload: GetReturnLossHistoryRequest) => {
	return useQuery<GetReturnLossHistoryResponse>({
		queryKey: [ReturnLossHistoryQueryKeys.GetReturnLossHistoryList, payload],
		queryFn: () => getReturnLossHistoryList(payload),
	})
}

export default useQueryGetReturnLossHistory
